import React from 'react';
import { Modal, ModalBody, Spinner } from 'reactstrap';
import { shallowEqual, useSelector } from 'react-redux';

export default function PreparingTestModal() {
  const { showPreparingAssessmentModal, productTypeSmall } = useSelector(
    state => ({
      showPreparingAssessmentModal:
        state.appStatus.showPreparingAssessmentModal,
      productTypeSmall: state.test.productTypeSmall,
    }),
    shallowEqual
  );

  return (
    <Modal
      backdrop
      isOpen={showPreparingAssessmentModal}
      size="md"
      centered
      id="do-test-preparing"
    >
      <ModalBody>
        <div className="row d-flex justify-content-center m-1">
          <Spinner size="md" color="primary" />
          &nbsp; &nbsp; &nbsp;
          <span style={{ fontSize: '18px' }}>
            Verifying {productTypeSmall} details, please wait
          </span>
        </div>
      </ModalBody>
    </Modal>
  );
}
